import React, { Dispatch, SetStateAction } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Button } from 'components/ui/button';
import { Icon } from 'components/ui/icon';
import { cn } from 'lib/utils';
import { SUMMARY_TYPE_OPTIONS } from '../../constants';

interface TipSummaryByDropdownProps {
  selected: string;
  setSummartType: Dispatch<SetStateAction<string>>;
}

const TipSummaryByDropdown = ({
  selected,
  setSummartType,
}: TipSummaryByDropdownProps): JSX.Element => {
  const selectedLabel =
    SUMMARY_TYPE_OPTIONS.find((opt) => opt.value === selected)?.label ??
    SUMMARY_TYPE_OPTIONS[0].label;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="inline-flex items-center gap-1 text-sm font-medium text-gray-blue-80 bg-white border border-gray-blue-10 hover:bg-gray-blue-5"
        >
          <Icon name="filter" size={18} aria-hidden="true" />
          <span>{selectedLabel}</span>
          <Icon name="chevron-down" size={16} aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56 p-1">
        {SUMMARY_TYPE_OPTIONS.map((opt) => {
          const isSelected = opt.value === selected;
          return (
            <DropdownMenuItem
              key={opt.value}
              onClick={() => {
                setSummartType(opt.value);
              }}
              className={cn(
                'flex items-center justify-between cursor-pointer px-3 py-2 text-sm focus:bg-gray-blue-5',
                isSelected && 'bg-gray-blue-5 font-medium'
              )}
            >
              <span>{opt.label}</span>
              {isSelected && (
                <Icon
                  name="check"
                  size={16}
                  className="text-dark-green-link"
                  aria-hidden="true"
                />
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TipSummaryByDropdown;
